import { UserOutlined } from '@ant-design/icons';
import { Card, Col, Flex, Layout, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { CButton } from '@/components/CButton';
import { HeaderLogo } from '@/components/HeaderLogo';
import { PageBanner } from '@/components/PageBanner';
import { FooterLinks } from '@/modules/auth/components/FooterLinks';

const { Header } = Layout;
const { Text, Link } = Typography;

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(['common', 'pages/login']);
  return (
    <Layout className="h-dvh c-legal-page">
      <Header className="header">
        <Flex justify="space-between" align="center" className="w-full">
          <Col>
            <Flex align="center">
              <div className="logo">
                <HeaderLogo />
              </div>
            </Flex>
          </Col>
          <Col className="flex justify-end">
            <CButton
              startIcon={<UserOutlined />}
              onClick={() => navigate('/login')}
              variant="primary"
            >
              {t('common:common.login')}
            </CButton>
          </Col>
        </Flex>
      </Header>
      <PageBanner title={t('pages/login:pages.login.footer.privacy_policy')} />

      <Layout className="layout-content">
        <Card>
          <section className="flex flex-col mb-4">
            <Text strong>1. Overview</Text>
            <Text>
              Our API Client uses <strong>YouTube API Services</strong> to provide its
              functionalities. We are committed to protecting your privacy while managing YouTube
              channel data internally.
            </Text>
          </section>
          <section className="flex flex-col mb-4">
            <Text strong>2. Google Privacy Policy</Text>
            <Text>
              This application uses Google’s APIs. You can find the{' '}
              <strong>Google Privacy Policy </strong>at{' '}
              <Link href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
                https://policies.google.com/privacy
              </Link>
              . We encourage you to review it as it governs how Google handles your information.
            </Text>
          </section>
          <section className="flex flex-col mb-4">
            <Text strong>3. Data Collection and Usage</Text>
            <Text>
              Our API Client accesses, collects, and stores the following YouTube API Data:{' '}
              <strong>Video analytics, revenue data, channel metadata, video metadata</strong>. This
              data is used solely for{' '}
              <strong>monitoring channel performance, managing videos and videos metadata</strong>.
              We do not share this information with external third parties.
            </Text>
          </section>
          <section className="flex flex-col mb-4">
            <Text strong>4. Cookies and Local Storage</Text>
            <Text>
              This application uses cookies or similar technologies to store session information and
              improve user experience on your device.
            </Text>
          </section>
          <section className="flex flex-col mb-4">
            <Text strong>5. Data Retention and Deletion</Text>
            <Text>
              Authorized data (tokens) are stored only as long as necessary to provide the services.
              Users can request the deletion of their stored data by contacting{' '}
              <strong>bt@merzigo.com</strong>
            </Text>
          </section>
          <section className="flex flex-col mb-4">
            <Text strong>6. Revoking Access</Text>
            <Text>
              Users can revoke the application's access to their data at any time via the{' '}
              <strong>Google Security Settings page</strong> at:{' '}
              <Link
                href="https://myaccount.google.com/connections"
                target="_blank"
                rel="noreferrer"
              >
                https://myaccount.google.com/connections
              </Link>
              .
            </Text>
          </section>
          <section className="flex flex-col mb-4">
            <Text strong>7. Contact Us</Text>
            <Text>
              If you have any questions, contact us at: <strong>bt@merzigo.com</strong>
            </Text>
          </section>
        </Card>
      </Layout>

      <FooterLinks />
    </Layout>
  );
};

export default PrivacyPolicy;
